var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 592,
    viewBox: "0 0 1440 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-148 516.717L-11.1111 480.786C125.778 443.145 399.556 369.572 673.333 369.572C947.111 369.572 1220.89 443.145 1494.67 492.763C1768.44 542.382 2042.22 566.335 2179.11 578.312L2316 592V0H2179.11C2042.22 0 1768.44 0 1494.67 0C1220.89 0 947.111 0 673.333 0C399.556 0 125.778 0 -11.1111 0H-148V516.717Z",
    fill: "#08D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondo);
export default __webpack_public_path__ + "static/media/fondo.13525150b1db3c3fe80bbb135e2f010f.svg";
export { ForwardRef as ReactComponent };